<template>
  <div></div>
</template>

<script>
import * as CCDb from "../../utilities/db"
export default {
  mounted() {
    CCDb.logout()
  }
}
</script>

<style lang="scss" scoped>
</style>